// App.js
import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Header from "./components/Header";
import MainSection from "./components/MainSection";
import Services from "./components/Services";
import Footer from "./components/Footer";
import Powerful from "./components/Powerful";
import InfiniteScroll from "./components/InfiniteScroll"; // Asegúrate de importar InfiniteScroll
import FloatingIcon from "./components/FloatingIcon";
import "./styles/App.scss";

gsap.registerPlugin(ScrollTrigger);

function App() {
  const appRef = useRef(null);
  const powerfulRef = useRef(null);
  const infiniteScrollRef = useRef(null); // Nueva referencia para InfiniteScroll

   useEffect(() => {
    // ScrollTrigger para el componente Powerful
    ScrollTrigger.create({
      trigger: powerfulRef.current,
      start: "top 25%",
      markers: false,
      onEnter: () => {
        gsap.to(appRef.current, {
          backgroundColor: "#E0A34B",
          duration: 0.8,
          ease: "power3.inOut",
        });
      },
      onLeaveBack: () => {
        gsap.to(appRef.current, {
          backgroundColor: "#1D1D1B",
          duration: 0.3,
          ease: "power3.inOut",
        });
      },
    });

    // ScrollTrigger para el componente InfiniteScroll
    ScrollTrigger.create({
      trigger: infiniteScrollRef.current,
      start: "top 25%",
      markers: false,
      onEnter: () => {
        gsap.to(appRef.current, {
          backgroundColor: "#D9D9D9", // Nuevo color de fondo
          duration: 0.8,
          ease: "power3.inOut",
        });
      },
      onLeaveBack: () => {
        gsap.to(appRef.current, {
          backgroundColor: "#E0A34B", // Vuelve al color de Powerful
          duration: 0.3,
          ease: "power3.inOut",
        });
      },
    });
  }, []);

  return (
    <div className="app" ref={appRef}>
      <FloatingIcon />
      <Header />
      <MainSection />
      <Services />
     <Powerful ref={powerfulRef} />
      <InfiniteScroll ref={infiniteScrollRef} />
      <Footer />

    </div>
  );
}

export default App;
